const PhoneRegex = /^01[0125][0-9]{8}$/gm

export { PhoneRegex }
